import airslides from './airslides.svg';

export const projectsData = [
  {
    projectName: "AirSlides",
    projectDescription:
      "Control presentations using hand gestures detected via the webcam. Features Next/Prev slide, Pointer, and Draw modes.",
    imageUrl: airslides,
    projectUrl: "https://github.com/khushi-saxena/AirSlides",
  },
  {
    projectName: "NaamKaran!",
    projectDescription:
      "It is a name suggestion application that will help you to give a good name to your next project.",
    imageUrl:
      "https://user-images.githubusercontent.com/62301468/121772560-a1326e80-cb93-11eb-9cd9-b106783241e2.png",
    projectUrl: "https://khushi-saxena.github.io/NaamKaran/",
  },
  {
    projectName: "Digital Hospital",
    projectDescription:
      "This is a website with the help of which doctors can view the reports of patients and can prescribe accordingly",
    imageUrl:
      "https://user-images.githubusercontent.com/62301468/121772656-58c78080-cb94-11eb-8d81-5095dbd9af75.png",
    projectUrl: "https://github.com/khushi-saxena/Digital_Hospital",
  },
  {
    projectName: "Expense-Tracker",
    projectDescription:
      "It is an Expense Tracker which helps you to keep a count of your expenses which you have made so far",
    imageUrl:
      "https://user-images.githubusercontent.com/62301468/121772771-371ac900-cb95-11eb-84af-a86327d030c5.png",
    projectUrl: "https://github.com/khushi-saxena/Expense-Tracker",
  },
  {
    projectName: "Resource-Hub",
    projectDescription:
      "This site has a compilation of everything you'll need for the smooth sailing of all years of your college life",
    imageUrl:
      "https://user-images.githubusercontent.com/62301468/121772815-8e209e00-cb95-11eb-89b0-4fc9e6b19f5e.png",

    projectUrl: "https://github.com/Khushi0321/Resource-Hub",
  },
  {
    projectName: "Portfolio Website",
    projectDescription: "My Own Portfolio Website",
    imageUrl:
      "https://user-images.githubusercontent.com/62301468/121772854-cb852b80-cb95-11eb-9f36-982a37803c55.png",

    projectUrl: "https://khushi-saxena.github.io/portfolio/#/",
  },
];
